import { ok } from "@redotech/util/fp/coerced-result";

export class UtmParameters {
  constructor(
    private params: {
      source?: string;
      medium?: string;
      campaign?: string;
      content?: string;
      contact?: string;
    },
  ) {}

  applyToUrl(url: string): string;
  applyToUrl(url: URL): URL;
  applyToUrl(url: URL | string): URL | string {
    if (typeof url === "string") {
      url = url.trim();
    }
    if (url.toString().includes("tel:")) return url;
    if (url.toString().includes("mailto:")) return url;
    if (typeof url === "string") {
      if (!url.match(/^https?:\/\//)) {
        url = `https://${url}`;
      }
      const urlResult = ok(url).map((url) => new URL(url));
      if (!urlResult.ok) return url;
      url = urlResult.value;
    }
    url = new URL(url.toString()); // avoid mutation
    if (this.params.source)
      url.searchParams.set("utm_source", this.params.source);
    if (this.params.medium)
      url.searchParams.set("utm_medium", this.params.medium);
    if (this.params.campaign)
      url.searchParams.set("utm_campaign", this.params.campaign);
    if (this.params.content)
      url.searchParams.set("utm_content", this.params.content);
    if (this.params.contact)
      url.searchParams.set("utm_contact", this.params.contact);

    return url;
  }

  getCampaign() {
    return this.params.campaign;
  }

  getSource() {
    return this.params.source;
  }

  getMedium() {
    return this.params.medium;
  }

  setContact(contact: string | undefined) {
    this.params.contact = contact;
  }

  getContact() {
    return this.params.contact;
  }
}

export class SmsUtmParameters extends UtmParameters {
  constructor({
    campaign,
    content,
    contact,
  }: {
    campaign?: string;
    content?: string;
    contact?: string;
  }) {
    super({ source: "redo", medium: "sms", campaign, content, contact });
  }

  override getSource(): string {
    return super.getSource() ?? "";
  }

  override getMedium(): string {
    return super.getMedium() ?? "";
  }
}
